import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { blackPvcDictEl } from "@/lib/shop/products/black-pvc";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/el/shop_/black-pvc")({
  head: () => ({
    ...buildProductHead(blackPvcDictEl),
    links: alternateLinkList("/shop/black-pvc", "el"),
  }),
  component: () => <ProductPage dict={blackPvcDictEl} />,
});
